import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

// Square viewBox so the triangle stays undistorted at the small sizes table headers use.
function Icon(props: Props) {
  return (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.5 3.5L5 7.5L8.5 3.5H1.5Z" fill="currentColor" />
    </svg>
  );
}

export default Icon;
